export const TABLE = 'table';
export const IS_LOADING = 'isLoading';
export const SORT_COLUMN = 'sortColumn';
export const SORT_DIRECTION = 'sortDirection';
export const CURRENT_PAGE = 'currentPage';
export const TOTAL_PAGES = 'totalPages';
export const TOTAL_ITEMS = 'totalItems';
export const PER_PAGE = 'itemsPerPage';
export const DATA = 'data';
export const FILTER = 'filter';
export const META = 'meta';
export const IS_SUCCESS_RESPONSE = 'isSuccess';
export const IS_FAIL_RESPONSE = 'isFail';
export const SUCCESS_RESPONSE = 'successResponse';
export const FAIL_RESPONSE = 'failResponse';

export const ALL_KEYS = {
  [TABLE]: TABLE,
  [IS_LOADING]: IS_LOADING,
  [SORT_COLUMN]: SORT_COLUMN,
  [SORT_DIRECTION]: SORT_DIRECTION,
  [CURRENT_PAGE]: CURRENT_PAGE,
  [TOTAL_PAGES]: TOTAL_PAGES,
  [TOTAL_ITEMS]: TOTAL_ITEMS,
  [PER_PAGE]: PER_PAGE,
  [DATA]: DATA,
  [FILTER]: FILTER,
  [META]: META,
  [IS_SUCCESS_RESPONSE]: IS_SUCCESS_RESPONSE,
  [IS_FAIL_RESPONSE]: IS_FAIL_RESPONSE,
  [SUCCESS_RESPONSE]: SUCCESS_RESPONSE,
  [FAIL_RESPONSE]: FAIL_RESPONSE
};
